.svgStrokeBlue path {
  stroke: var(--pm-blue);
}

:global(.dark) .svgStrokeBlue path {
  stroke: var(--pm-blue-lighter);
}

.svgFillBlue path {
  fill: var(--pm-blue);
}

:global(.dark) .svgFillBlue path {
  fill: var(--pm-blue-lighter);
}
